import { SERVICE_CATEGORIES } from '../../../adlevo-vue/appConfiguration';
import toggleClassModifiers from '../../../utils/toggleClassModifiers';
import { escapeHtml } from '../../../utils/stringHelpers';
import ActivityCartItem from './ActivityCartItem';
import HotelRoomTypeCartItem from './HotelRoomTypeCartItem';
import { CartValidationRequest } from '../../checkout/request/cartValidationRequest';
import api from '../../../utils/appApi';

const STORAGE_KEY =  'cart-items';
const STORAGE = localStorage;

/** get CartItem Objects frm Storage */
export const getCartItemsFromStorage = () => {
	let cartItems = STORAGE.getItem(STORAGE_KEY);
	if(cartItems){
		cartItems = JSON.parse(cartItems);
		return cartItems.map(cartItem => {
			return createCartItem(cartItem.type, cartItem)
		});
	}
	return [];
}

export default class Cart {
	constructor() {
		this.cartItems = [];
		// Elements
		this.cartItemsWrapper = document.getElementById('cart-filled-wrapper');
		this.cartItemsContainer = document.getElementById('cart-filled');
		this.cartEmptyContainer = document.getElementById('cart-empty-wrapper');
		this.totalCartCountElement = document.getElementById('checkout-item-count');
		this.cartButton = document.getElementById('cart-button');
		this.cartButtonMobile = document.getElementById('cart-button-mobile');
		this.cartWrapper = document.getElementById('cart-wrapper');
		this.cartFooter = document.getElementById('cart-footer');
		this.mainElement = document.getElementById('main');
		this.body = document.getElementById('body');
		this.menuOverlayForCart = document.getElementById('menuOverlay');
		this.closeButton = document.getElementById('close-button');
		this.cartTotalPrice = document.getElementById('cart-total-text');
		this.cartTotalPriceCurrency = document.getElementById('cart-total-currency');
		this.totalCartCountMobileElement = document.getElementById('mobile-checkout-item-count');
		
		// Validate Cart Items and Render
		this.validateCartItems(null);
		if(this.cartButton || this.cartButtonMobile){
			if(this.cartButton){
				this.cartButton.addEventListener('click', this._toggleCartModal.bind(this));
			}
			if(this.cartButtonMobile){
				this.cartButtonMobile.addEventListener('click', this._toggleCartModal.bind(this));
			}
		}
		this.closeButton.addEventListener('click', this._toggleCartModal.bind(this));

		/**
		 * communication with Cart Module will go with Events
		 * */
		document.addEventListener('addItemToCart', this.onAddItemToCart.bind(this));
		document.addEventListener('validateCartItems', this.validateCartItems.bind(this));
		document.addEventListener('showCartModal', function(event) {
			event.preventDefault();
			this._toggleCartModal(true);
		}.bind(this));
		document.addEventListener('clearCartItems',this.onClearCartItems.bind(this));
	}

	/** Validate CartItems
	 * @param {Event} event
	 */
	async validateCartItems(event) {
		try {
			const cartItems = getCartItemsFromStorage();
			if(!cartItems.length){
				dispatchValidateCartItemsSuccess(null);
				this.renderCartItems([]);
				return;
			}
			dispatchValidateCartItemsRequest();
			const params = event && event.detail ? event.detail : {};
			const requestBuilder = new CartValidationRequest(cartItems);
			// nosemgrep: insecure-object-assign -- `params` comes from a document-level
			// CustomEvent('validateCartItems', {detail}); no dispatcher anywhere in this
			// codebase sends real detail data today (only `validateCartItems(null)` is
			// ever called), so there's no live attacker-reachable path feeding this
			// merge. requestBuilder.buildRequest() is spread last, so tours/hotels
			// can't be overridden by params either way.
			const requestParams = Object.assign({}, params, requestBuilder.buildRequest());
			const response = await api.public.checkout.validate(requestParams);
			const responseData = response.data.data || response.data;
			this.updateCartItemsAccordingToItemStatus(responseData, cartItems, requestParams);
		}catch (error) {
			console.log(error);
			dispatchValidateCartItemsFailed(error);
		}
	}

	updateCartItemsAccordingToItemStatus(responseData, cartItems, requestParams){
		var resultCartItems = [];
		let isCartItemsValid = (responseData.tours && !responseData.tours.status) && (responseData.hotels && !responseData.hotels.status)
		if(isCartItemsValid) {
			resultCartItems = []
			const element = document.getElementById('noCartItemSection')
			if(element) {
				element.innerHTML = `<p class="subtitle-2 font-weight-medium">Your cart is empty</p>` +
									`<p class=" body-2">` +
				`${escapeHtml(responseData.tours.message || responseData.hotels.message)}` +
				`</p>` +
				`<p class="subtitle-2 font-weight-medium"></p>`
			}
		} else {
			cartItems.forEach(cartItem => {
				let status = false;
				switch (cartItem.getType()) {
					case SERVICE_CATEGORIES.ACTIVITIES:
						const data = responseData.tours.items[cartItem.id];
						if(data){
							status = data.status;
							cartItem.updateData(data);
						}
						break;
					case SERVICE_CATEGORIES.HOTELS:
						const rooms = responseData.hotels.items[cartItem.id].items;
						const roomsInCarts = cartItem.getRooms();
	
						const updatedRooms = roomsInCarts.reduce((roomResults, roomType) => {
							const roomDetails = rooms.find(room => room.room_type_id === roomType.roomTypeId);
							if(roomDetails && roomDetails.status){
								roomResults.push({
									...roomType,
									price: roomDetails.rate_plan.price,
									// total: roomDetails.total,
									status: roomDetails.status
								});
								status = true;
							}
							return roomResults;
						}, []);
						cartItem.setRooms(updatedRooms);
						break;
				}
	
				if(status){
					resultCartItems.push(cartItem);
				}
			});
		}
		this.updateCartItemToStorage(resultCartItems);
		dispatchValidateCartItemsSuccess({
			cartItems: resultCartItems,
			params: requestParams,
			response: responseData,
		});
		this.renderCartItems(resultCartItems);
	}

	/** handler for addItemToCart
	 * @param {Event} event
	 * @param {CartItem} event.detail
	 * */
	onAddItemToCart(event) {
		const newCartItem = event.detail;
		const element = document.getElementById('tourAvailabilityContainer')
		if(element) {
			const isProcessSingleItem = element.getAttribute('process-single-cart-item')
			if(isProcessSingleItem === 'true') {
				this.onClearCartItems()
			} 
		}
		const cartItems = getCartItemsFromStorage();
		const cartItem = cartItems.find(cartItem => cartItem.isMatched(newCartItem));
		let isCurrencyTypeSimiar = true 
		let totalCurrency = newCartItem.currency_type
		cartItems.forEach(item => {
			if(item.currency_type !== totalCurrency) {
				isCurrencyTypeSimiar = false
			}	
		})
		if(isCurrencyTypeSimiar) {
			if(cartItem){
				cartItem.updateData(newCartItem);
			}else {
				cartItems.push(newCartItem);
			}
		}
		this.updateCartItemToStorage(cartItems);
		this.renderCartItems(cartItems);
		dispatchAddToCartSuccess(cartItem);
	}

	onClearCartItems() {
		this.updateCartItemToStorage([]);
	}

	/** Update CartItems to storage
	 * @param {CartItem[]} cartItems
	 * */
	updateCartItemToStorage(cartItems) {
		STORAGE.setItem(STORAGE_KEY, JSON.stringify(cartItems));
	}

	getCurrencyType(cartItems) {
        let currencyType = null;
		if(cartItems && cartItems.length) {
			cartItems.forEach(cartItem => {
				switch (cartItem.getType()) {
					case SERVICE_CATEGORIES.ACTIVITIES:
						if(currencyType === null) {
							currencyType = cartItem.currency_type
						}
						break;
					case SERVICE_CATEGORIES.HOTELS:
						if(currencyType === null) {
							currencyType = cartItem.currency_type
						}
						break;
				}
			});
		}
        return currencyType ? currencyType : getUserCurrency() 
    }

	/**
	 * Render Cart Items to Cart Modal
	 * @param {CartItem[]} cartItems
	 * */
	renderCartItems(cartItems) {
		const totalCartItems = cartItems.length;
		if (!totalCartItems) {
			this.cartEmptyContainer.classList.remove('--hidden');
			this.cartItemsWrapper.classList.add('d-none');
			this.cartFooter.classList.add('d-none');
			this.totalCartCountElement.innerText = '';
			this.totalCartCountMobileElement.innerText = '';
			this.cartItemsContainer.innerHTML = '';
			return;
		}

		this.cartItemsContainer.innerHTML = '';
		let total = 0;
		cartItems.forEach(cartItem => {
			total += Number(cartItem.getTotal());
			this.cartItemsContainer.appendChild(cartItem.getHtmlCard());
		});
		if(this.cartTotalPrice) {
			this.cartTotalPrice.innerText = total.toFixed(2);
		}
		if(this.cartTotalPriceCurrency) {
			this.cartTotalPriceCurrency.innerText = this.getCurrencyType(cartItems);
		}
		this.setTotalCountOfCartItems(totalCartItems);
		this._toggleCartElementsClasses();

		document.querySelectorAll('.cart-item-remove-btn').forEach(element => {
			element.removeEventListener('click', this.onRemoveCartItem.bind(this))
			element.addEventListener('click', this.onRemoveCartItem.bind(this))
		});
		// for hotels only
		document.querySelectorAll('.cart-room-type-item-remove-btn').forEach(element => {
			element.removeEventListener('click', this.onRemoveRoomTypeCartItem.bind(this))
			element.addEventListener('click', this.onRemoveRoomTypeCartItem.bind(this))
		});

	}

	onRemoveCartItem(event) {
		event.preventDefault();
		const serviceType = event.target.getAttribute('data-type');
		const id = event.target.getAttribute('data-id');
		const cartItems = getCartItemsFromStorage();

		const updatedCartItems = cartItems.filter(cartItem => {
			return !(this.isCartItemMatchedWithServiceTypeAndId(serviceType, cartItem, id));
		});

		this.updateCartItemToStorage(updatedCartItems);
		dispatchCartItemsRemoved();
		dispatchValidateCartItems();
		this.renderCartItems(updatedCartItems);
	}

	isCartItemMatchedWithServiceTypeAndId(serviceType, cartItem, id) {
		return cartItem.getType() === serviceType && cartItem.getId() === Number(id)
	}

	onRemoveRoomTypeCartItem(event) {
		event.preventDefault();
		const serviceType = event.target.getAttribute('data-type');
		const id = event.target.getAttribute('data-id');
		const roomTypeId = event.target.getAttribute('data-room-type-id');
		const cartItems = getCartItemsFromStorage();
		let updatedCartItems = [];
		let updatedCartRooms = [];
		const cartItem = cartItems.find(cartItem => {
			return (this.isCartItemMatchedWithServiceTypeAndId(serviceType, cartItem, id));
		});

		if (cartItem) {
			updatedCartRooms = cartItem.rooms.filter(room => {
				return !(room.roomTypeId === Number(roomTypeId));
			})
		}
		cartItem.rooms = updatedCartRooms;
		updatedCartItems = cartItems.filter(cartItem => {
			return !(this.isCartItemMatchedWithServiceTypeAndId(serviceType, cartItem, id));
		});

		if (cartItem.rooms.length) {
			updatedCartItems.push(cartItem);
		}
		this.updateCartItemToStorage(updatedCartItems);
		dispatchCartItemsRemoved();
		dispatchValidateCartItems();
		this.renderCartItems(updatedCartItems);
	}

	setTotalCountOfCartItems(totalCartItems) {

		if(!this.totalCartCountElement || !this.totalCartCountMobileElement){
			return;
		}

		this.totalCartCountElement.innerText = totalCartItems.toString().trim();
		this.totalCartCountMobileElement.innerText = totalCartItems.toString().trim();

		if(this.totalCartCountElement.classList.contains('d-none')){
			this.totalCartCountElement.classList.toggle('d-none');
		}
		if(this.totalCartCountMobileElement.classList.contains('d-none')){
			this.totalCartCountMobileElement.classList.toggle('d-none');
		}
	}

	_toggleCartElementsClasses() {

		if(this.cartItemsWrapper.classList.contains('d-none')){
			this.cartItemsWrapper.classList.toggle('d-none');
			this.cartFooter.classList.toggle('d-none');
		}

		if(!this.cartEmptyContainer.classList.contains('--hidden')){
			this.cartEmptyContainer.classList.toggle('--hidden');
		}
	}

	_toggleCartModal(hardOpen = false) {
		toggleClassModifiers(
			[
				[this.cartButton, '--clicked'],
				[this.cartWrapper, '--active'],
				[this.mainElement, '--blur'],
				[this.body, '--overflow-disabled'],
			],
			{ add: hardOpen },
		);
		this.menuOverlayForCart.classList.toggle('showMenuOverlay');

	}

}

/** Dispatch add to cart Event
 * @param {Object} data
 * */
export const dispatchAddToCart = (data, isHotelAddTocartBtn = false) => {
	if (isHotelAddTocartBtn) {
		const event = new CustomEvent("showCartModal");
		document.dispatchEvent(event);
	}
	const event = new CustomEvent("addItemToCart", {
		detail: data
	});
	document.dispatchEvent(event);
}

/** Dispatch add to cart Event
 * @param {CartItem} cartItem
 * */
export const dispatchAddToCartSuccess = (cartItem) => {
	const event =  new CustomEvent("addItemToCartSuccess", {
		detail: cartItem
	});
	document.dispatchEvent(event);
}

export const dispatchClearCartItems = (cartItem) => {
	const event =  new CustomEvent("clearCartItems",{
		detail: cartItem
	});
	document.dispatchEvent(event);
}

/** Dispatch a Validate Cart Items Request
 * @param { Object} params
 * */
export const dispatchValidateCartItems = (params) => {
	const event =  new CustomEvent("validateCartItems", {
		detail: params
	});
	document.dispatchEvent(event);
}

/** Dispatch a Validate Cart Items Request
 * @param { Object} params
 * */
export const dispatchValidateCartItemsRequest = (params) => {
	const event =  new CustomEvent("validateCartItemsRequest", {
		detail: params
	});
	document.dispatchEvent(event);
}

/** Dispatch a Validate Cart Items Success
 * @param {Object} data
 * */
export const dispatchValidateCartItemsSuccess = (data) => {
	const event =  new CustomEvent("validateCartItemsSuccess", {
		detail: data
	});
	document.dispatchEvent(event);
}

/** Dispatch a Validate Cart Items Failed
 * @param {Error} error
 * */
export const dispatchValidateCartItemsFailed = (error) => {
	const event =  new CustomEvent("validateCartItemsFailed", {
		detail: error
	});
	document.dispatchEvent(event);
}

/** Dispatch a Cart Item Removed
 * */
export const dispatchCartItemsRemoved = () => {
	const event =  new CustomEvent("cartItemsRemoved");
	document.dispatchEvent(event);
}

/**
 * It will create a Cart Item Form Data
 * @param {string} type - It will be from SERVICE_CATEGORIES
 * @param {Object} data
 * */
export const createCartItem = (type, data) => {
	switch (type){
		case SERVICE_CATEGORIES.HOTELS:
			return new HotelRoomTypeCartItem(data);

		case SERVICE_CATEGORIES.ACTIVITIES:
			return new ActivityCartItem(data);
	}
}